'use strict';
const angular = require('angular');

export class incidentLocationComponent {
  constructor(appConfig) {
    'ngInject';

    this.constants = appConfig;
  }
}

export default angular.module('hccApp.incidentLocation', [])
  .component('incidentLocation', {
    template: require('./incidentLocation.html'),
    bindings: { incident: '=' },
    controller: incidentLocationComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/incident/incidentLocation/incidentLocation.component.js